import { useContext } from "react";
import { formatAddress } from "../../../shared/utils/formatters";
import { WalletContext } from "../components/shared-wallet-context";
import { WalletAdapterStatus } from "../utils/types";

export function useWalletInfo() {
  // Get wallet context
  const wallet = useContext(WalletContext);

  if (!wallet) {
    throw new Error("useWalletInfo must be used within a WalletProvider");
  }

  const { status, selectedAccount } = wallet;

  const isConnected = status === WalletAdapterStatus.CONNECTED && !!selectedAccount;
  const address = selectedAccount?.address;
  const chainId = selectedAccount?.chainId;

  return {
    // Account info
    address,
    formattedAddress: formatAddress(address),
    isConnected,
    chainId,
  };
}
